<p-toast key="globalInfoNotification" position="bottom-right"></p-toast>
<p-toast key="globalSuccessNotification" position="bottom-right"></p-toast>
<p-toast key="globalWarningNotification" position="bottom-right"></p-toast>
<p-toast key="globalErrorNotification" position="bottom-right"></p-toast>